/**
 * What `@tanstack/*-devtools` resolves to under `whop({ disableTanstackDevtools:
 * true })`.
 *
 * The TanStack scaffold mounts `<TanStackDevtools>` in `__root.tsx`, which puts a
 * floating panel trigger over every page. On a developer's own machine that is
 * the point; on a site being watched by the person it is being built for, the
 * control belongs to nobody.
 *
 * Aliased rather than edited out of `__root.tsx`: the app's components stay
 * exactly as their author wrote them, and there is no JSX rewriting to get wrong.
 * What the project does carry is the one flag that asks for this, so the missing
 * panel is explained by the config rather than by the environment.
 */

function nothing(): null {
	return null;
}

export const TanStackDevtools = nothing;
export const TanStackRouterDevtools = nothing;
export const TanStackRouterDevtoolsPanel = nothing;
export const ReactQueryDevtools = nothing;
export const ReactQueryDevtoolsPanel = nothing;

export default nothing;
